export class LessonStates {
  static readonly RESERVATION = '予約依頼中';
  static readonly COMMIT = '予約確定';
  static readonly TRANSFAR = '振替依頼';
  static readonly ALREADY = '実施済';
  static readonly DELETED = '削除';

  static getStateCode(state: string) {
    switch (state) {
      case this.RESERVATION:
        return 'RESERVATION';
      case this.COMMIT:
        return 'COMMIT';
      case this.TRANSFAR:
        return 'TRANSFAR';
      case this.ALREADY:
        return 'ALREADY';
      case this.DELETED:
        return 'DELETED';
      default:
        return 'DELETED';
    }
  }
  static getDaState(lesson: string | undefined) {
    if (lesson === LessonStates.RESERVATION) {
      return '予約承認待ち';
    }
    if (lesson === LessonStates.DELETED) {
      return 'キャンセル済';
    }
    return lesson;
  }
  static getBadgeClassByState(state: string | undefined, withBadgeCss = true) {
    const result = [];
    if (withBadgeCss) {
      result.push('badge');
      result.push('badge-pill');
    }
    if (LessonStates.RESERVATION === state || this.getDaState(LessonStates.RESERVATION) === state) {
      result.push('badge-primary');
      return result;
    }
    if (LessonStates.COMMIT === state) {
      result.push('badge-success');
      return result;
    }
    if (LessonStates.ALREADY === state) {
      result.push('badge-info');
      return result;
    }
    if (LessonStates.TRANSFAR === state) {
      result.push('badge-danger');
      return result;
    }

    if (LessonStates.DELETED === state) {
      result.push('badge-dark');
      return result;
    }

    result.push('badge-light');
    return result;
  }
}
